export default function Roadmap() {
    return (
        <div id="roadmap" className="container text-center">
            <h2 className="mb-5">Roadmap</h2>
            <p>Project roadmap coming soon!</p>
        </div>
    );
}
